import { SvgIcon } from '@mui/material'

// Types
import { SvgIconProps } from '@mui/material'

const ChartIconAtom = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 51 51">
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={5}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M8.5425 12.6862C5.84375 16.2562 4.25 20.6975 4.25 25.5C4.25 37.23 13.77 46.75 25.5 46.75C37.23 46.75 46.75 37.23 46.75 25.5C46.75 13.77 37.23 4.25 25.5 4.25"
			/>

			<g opacity={0.4}>
				<path
					fill="none"
					stroke="currentColor"
					strokeWidth={5}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M10.625 25.5C10.625 33.7237 17.2763 40.375 25.5 40.375C33.7237 40.375 40.375 33.7237 40.375 25.5C40.375 17.2763 33.7237 10.625 25.5 10.625"
				/>

				<path
					fill="none"
					stroke="currentColor"
					strokeWidth={5}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M25.5 34C30.1963 34 34 30.1963 34 25.5C34 20.8037 30.1963 17 25.5 17"
				/>
			</g>
		</SvgIcon>
	)
}

export default ChartIconAtom
